import React, { Component } from 'react';


class UserMovieList extends Component {
  render() {
    return (
    	<div>
    		bienvenido a UserMovieList
    	</div>
    )            
  }
}

export default UserMovieList;


/** WEBPACK FOOTER **
 ** ./src/components/UserMovieList.js
 **/